// Recovered compiled webpack factory 46934. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { e: () => n });
  function n(t, e, i) {
    e.startsWith("--") ? t.style.setProperty(e, i) : (t.style[e] = i);
  }
}
